import { gql } from '@apollo/client';
import { TagMappingFragment, TagNodeFragment } from './fragments';

export const SEARCH_TAGS = gql`
  query SearchTags(
    $schemaId: ID!
    $searchTerm: String
    $tags: [TagOptionInput!]!
    $managedOnly: Boolean!
  ) {
    searchTags(
      schemaId: $schemaId
      searchTerm: $searchTerm
      tags: $tags
      managedOnly: $managedOnly
    ) {
      defaultNodeIndex
      nodes {
        ...TagNodeFields
      }
      mapping {
        ...TagMappingFields
      }
    }
  }
  ${TagMappingFragment}
  ${TagNodeFragment}
`;
